"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalContext = void 0;
var GlobalContext = /** @class */ (function () {
    function GlobalContext(name, version, fields) {
        this.name = name;
        this.ts_ms = Date.now();
        this.version = version;
        this.fields = fields;
    }
    return GlobalContext;
}());
exports.GlobalContext = GlobalContext;
//# sourceMappingURL=globalcontext.js.map